/* ============
 * All Cities
 * ============
 *
 * All cities from a country.
 */

import Vue from 'vue';
import store from './../../store';
import additionalCodeTransformer from './../../transformers/additionalCode';

const success = ({ data }, resolve) => {
  const exciseAdditionals = additionalCodeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAdditionalCode', { exciseAdditionals });
  resolve();
};

const failed = () => {
};

// Display cities related to a country.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('additional_code')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/additionalCode/all.js